import React, { createContext, useState, useContext, useEffect } from 'react';
import { formatLastSeen, formatPosition } from '../constants/darkorbit-constants';

const InRangePlayersContext = createContext();

export const useInRangePlayers = () => useContext(InRangePlayersContext);

export const InRangePlayersProvider = ({ children }) => {
  const [inRangePlayers, __setInRangePlayers] = useState([]);

  // Update localStorage whenever inRangePlayers changes
  // Below doesn't work cause data is too large
  // useEffect(() => {
  //   if (inRangePlayers.length > 0) {
  //     try
  //     {
  //       localStorage.setItem("in-range-players", JSON.stringify(inRangePlayers));
  //     }
  //     catch  (e) {
  //       if (e.name === 'QuotaExceededError' || e.code === 22) {
  //           console.warn('Storage quota exceeded. Clearing and retrying…');
  //           localStorage.removeItem("in-range-players"); 
  //       } else {
  //           console.error('Unexpected storage error:', e);
  //       }
  //   }
  //   }
  // }, [inRangePlayers]);

  // Function to merge new players with existing ones
  function setInRangePlayers(newPlayers) {
    const playerMap = new Map(inRangePlayers.map(player => [player.user_id, player]));
    newPlayers.forEach(player => {
      playerMap.set(player.user_id, 
        {
            ...player,
            formattedPosition: formatPosition(player.position_x, player.position_y),
            formattedLastSeen: formatLastSeen(player.updated_at)
        });
    });

    __setInRangePlayers(Array.from(playerMap.values()));
  };

  // Load initial data from localStorage on mount
  useEffect(() => {
      localStorage.removeItem("in-range-players");
      // Below doesn't work since data is too large
      // try {
      //   const savedPlayers = localStorage.getItem("in-range-players");
      //   if (savedPlayers) {
      //     const parsedPlayers = JSON.parse(savedPlayers);
      //     setInRangePlayers(parsedPlayers);
      //   }
      // } catch (error) {
      //   console.error('Error loading players from localStorage:', error);
      // }
  }, []);

  const value = {
    inRangePlayers,
    setInRangePlayers
  };

  return (
    <InRangePlayersContext.Provider value={value}>
      {children}
    </InRangePlayersContext.Provider>
  );
};